import { SIZE_PACKS } from "../constants/action-types";
import { handleActions } from "redux-actions";
import { IBaseStoreState, IProgressive, progressActions } from "./base-reducers";

export interface IExportActionTypes {
    PROCESS: IProgressive;
    DOWNLOAD: IProgressive & { RESET_STATE: string };
    JOB: {
        POLL: {
            START: string;
            STOP: string;
        };
        FETCH: IProgressive;
    };
}

export interface IExportJobPayload {
    message?: string;
    job?: any;
    fileLink?: string;
    errors?: string[];
}

export interface IExportState extends IBaseStoreState<IExportJobPayload> {
    isExporting: boolean;
    isProcessing: boolean;
    isFetching: boolean;
    isFileFetching: boolean;
    isWaitingForDownloadLink: boolean;
    payload: IExportJobPayload;
    errors: string[];
}

export interface IUploadState {
    isUploading: boolean;
    uploadFinished: boolean;
}

export const sizePacksUpload = handleActions(
    {
        ...progressActions(SIZE_PACKS.UPLOAD, "isUploading"),
        [SIZE_PACKS.UPDATE_IMPORT]: (state: IUploadState, { payload }: { payload: Partial<IUploadState> }) => ({
            ...state,
            ...payload,
        }),
    } as any,
    { uploadFinished: false, isUploading: false }
);

export const sizePacksExport = handleActions(
    {
        ...progressActions(SIZE_PACKS.EXPORT.DOWNLOAD, "isExporting"),
        ...progressActions<IExportJobPayload, IExportState>(SIZE_PACKS.EXPORT.JOB.FETCH, "isFetching"),
        ...progressActions<IExportJobPayload, IExportState>(SIZE_PACKS.EXPORT_FILE.FETCH, "isFileFetching"),
        [SIZE_PACKS.EXPORT.PROCESS.START]: (state) => ({ ...state, isProcessing: true, errors: null }),
        [SIZE_PACKS.EXPORT.PROCESS.SUCCESS]: (state) => ({ ...state, isProcessing: false, errors: null }),
        [SIZE_PACKS.UPDATE_EXPORT]: (state: IExportState, { payload }: { payload: Partial<IExportState> }) => ({
            ...state,
            ...payload,
        }),
    } as any,
    { isExporting: false, errors: null, payload: {}, isProcessing: false, isFetching: false, isFileFetching: false }
);
